import React, { useState, useEffect } from "react";
import CarButton from "../components/CarButton";

const Section14 = ({ contenuti }) => {
  const contenutiArray = Array.isArray(contenuti)
    ? contenuti
    : Object.values(contenuti);

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {contenutiArray.map((content, index) => {
        // correggo qui i nomi
        const {
          titolo_1: titolo1,
          titolo_2: titolo2,
          immagine_url: immagineBg,
          immagini_aggiuntive: immaginiAggiuntive,
          call_to_action_it: callToAction,
          link_it: link,
        } = content;

        return (
          <>
          
          <div
            key={index}
            className="container-fluid d-flex flex-column align-items-center justify-content-start position-relative"
            style={{
              padding: "96px 16px",
              gap: "16px",
              backgroundImage: `url(${immagineBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            {/* Titolo della sezione */}
            <div className="title-section text-center">
              <h2
                className={`white-text ${isMobile
                    ? "d-inline-block d-lg-none title-section-mobile"
                    : "d-none d-lg-inline-block title-section"
                  }`}
              >
                {titolo1}
              </h2>{" "}
              <h2
                className={`light-green-text ${isMobile
                    ? "d-inline-block d-lg-none title-section-mobile"
                    : "d-none d-lg-inline-block title-section"
                  }`}
              >
                {titolo2}
              </h2>
            </div>

            {/* Immagini aggiuntive */}
            <div className="container">
              <div className="d-flex flex-column flex-md-row justify-content-between">
                {immaginiAggiuntive?.map((img, idx2) => (
                  <div
                    key={idx2}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <img
                      src={img.immagine_path}
                      alt={`Image ${idx2 + 1}`}
                      className="img-fluid"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Bottone */}
            <div className="d-flex justify-content-center align-items-center gap-3 mt-4">
              <CarButton
                text={callToAction}
                to={'/insegne-mappa#puntiVendita'}
                customClass="btn btn-two text-uppercase"
              />
            </div>
          </div>
          </>
        );
      })}
    </>
  );
};

export default Section14;
